import React, {Component} from 'react';
import '@assets/sass/components/form/switch.scss';
import * as ReactDOM from "react-dom";

export default class Switch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            checked: this.props.checked || false,
            moving: false,
        };

        this.handleClick = this.handleClick.bind(this);
        this.handleTouchStart = this.handleTouchStart.bind(this);
        this.handleTouchMove = this.handleTouchMove.bind(this);
        this.handleTouchEnd = this.handleTouchEnd.bind(this);

        this.setChecked = checked => {
            this.setState({
                checked: checked
            });
            if (typeof this.props.onChange === 'function') {
                this.props.onChange(checked);
            }
        };
    }

    componentDidMount() {
        const switchButton = ReactDOM.findDOMNode(this);
        this.minLeftOffset = 2;
        this.maxLeftOffset = switchButton.getBoundingClientRect().width - switchButton.querySelector('span').getBoundingClientRect().width - 2;
    }

    handleClick() {
        const {windowScrolled} = this.props;
        const duration = 200;

        if (windowScrolled) {
            this.scrollTop(duration)
        } else {
            this.setChecked(!this.state.checked);
        }
    }

    scrollTop = (duration) => {
        const {checked, onSwitcherScroll} = this.props;
        const scrollStep = -window.scrollY / (duration / 30);
        
        console.log('hello');

            const scrollInterval = setInterval(() => {

                if (window.scrollY !== 0) {
                    onSwitcherScroll()
                    window.scrollBy(0, scrollStep);
                } else {
                    clearInterval(scrollInterval)
                    if (this.props.setLimitDefault) {
                        this.props.setLimitDefault()
                    }
                    if (!checked) {
                        setTimeout(() => {
                            this.setChecked(!this.state.checked)
                        }, 200)
                    }
                }
            }, 30);
    }

    handleTouchStart(event) {
        this.touchStartPos = event.touches.item(0).clientX;
    }

    handleTouchMove(event) {
        this.setState(() => ({
            moving: true
        }));
        const switchButton = ReactDOM.findDOMNode(this);
        const touch = event.touches.item(0);
        let leftOffset = this.state.checked ? (this.touchStartPos - touch.clientX) : (touch.clientX - this.touchStartPos);
        if (leftOffset < this.minLeftOffset) {
            leftOffset = this.minLeftOffset;
        } else if (leftOffset > this.maxLeftOffset) {
            leftOffset = this.maxLeftOffset;
        }

        const circle = switchButton.querySelector('span');
        if (this.state.checked === false) {
            circle.style.left = leftOffset + "px";
        } else {
            circle.style.left = (this.maxLeftOffset - leftOffset) + "px";
        }

        if (parseFloat(circle.style.left) >= (this.maxLeftOffset - this.minLeftOffset) / 2) {
            switchButton.classList.add('checked');
        } else {
            switchButton.classList.remove('checked');

        }
    }

    handleTouchEnd() {
        // detect if it's a drag, or a tap
        if (this.state.moving === true) {
            const switchButton = ReactDOM.findDOMNode(this);
            let leftOffset = parseFloat(switchButton.querySelector('span').style.left);
            if (leftOffset >= (this.maxLeftOffset - this.minLeftOffset) / 2) {
                this.setChecked(true);
            } else {
                this.setChecked(false);
            }
            switchButton.querySelector('span').style.left = '';
        }
        this.setState(() => ({
            moving: false
        }));
    }

    isFiltersAdded = () => {
        const {counter, defaultCount} = this.props;
        return counter > defaultCount
    }

    render() {
        const {counter, defaultCount, uniqueID} = this.props;

        return (
            <div
                className={"switch-button" +
                (this.state.checked || this.props.checked ? ' checked' : '') +
                (this.isFiltersAdded() ? ' active' : '')
                }
                id={uniqueID ? uniqueID : ''}
                onClick={this.handleClick}
                onTouchStart={this.handleTouchStart}
                onTouchMove={this.handleTouchMove}
                onTouchEnd={this.handleTouchEnd}
            >
                <span>{this.isFiltersAdded() && (counter - defaultCount)}</span>
            </div>
        )
    }
}